"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
function default_1({ viewUrl, title, maxWidth768, isMasonryMobile, isDemandSurvey, isCommission, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("a", Object.assign({ href: viewUrl, onClick: e => (0, webview_app_1.stackRoomViewPage)({ roomViewUrl: viewUrl, e }), className: "text_overflow no_anchor_deco caption1", css: {
            WebkitLineClamp: 2,
            position: 'relative',
            height: isMasonryMobile && maxWidth768 ? 'unset' : '40px',
            color: 'rgba(0, 0, 0, 0.8)',
        } }, { children: [isDemandSurvey && (0, jsx_runtime_1.jsx)("span", { children: `[${t('수요조사')}] ` }), isCommission && (0, jsx_runtime_1.jsx)("span", { children: `[${t('커미션')}] ` }), title] })));
}
exports.default = default_1;
